<div class="paybee-modal-header">
    <div class="row">
        <div class="col-10">
            <div class="modal-main-heading">Download Excel</div>
        </div>
        <div class="col-2">
            <button type="button" class="close cursor--pointer" (click)="onCloseClick()">
                <span aria-hidden="true" class="black-text cursor--pointer">×</span>
            </button>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <div class="modal-sub-heading">Select QR Code size</div>
        </div>
    </div>
</div>

<div class="modal-body" [formGroup]="form">
    <mdb-form-control class="form-fill">
        <mdb-select formControlName="qrCodeSize" class="mdb-select">
            @for(option of options; track option) {
                <mdb-option [value]="option.id">{{option.label}}</mdb-option>
            }
        </mdb-select>
        <label mdbLabel class="form-label form-label--paybee">Size</label>
    </mdb-form-control>
</div>

<div class="modal-footer paybee-modal-footer">
    <a (click)="onCloseClick()" class="btn btn-sm modal-cancel-button waves-effect waves-light">Cancel</a>
    <a (click)="onDownloadClick()" class="btn btn-sm modal-confirm-button waves-effect waves-light">Download</a>
</div>